import businessFundActionTypes from './business-fund.types';

/** ***************** ADD BUSINESS FUND DETAILS START *********************** */
export const addBusinessFundDetailsStart = (addData: any) => ({
	type: businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_START,
	payload: addData,
});

export const addBusinessFundDetailsSuccess = (successData: any) => ({
	type: businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_SUCCESS,
	payload: successData,
});

export const addBusinessFundDetailsFailure = (failureData: any) => ({
	type: businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_FAILURE,
	payload: failureData,
});

export const addBusinessFundDetailsResponseResetStart = () => ({
	type: businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
});

export const addBusinessFundDetailsResponseChanged = () => ({
	type: businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD BUSINESS FUND DETAILS END *********************** */

/** ***************** UPDATE BUSINESS FUND DETAILS START *********************** */
export const updateBusinessFundDetailsStart = (updateData: any) => ({
	type: businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_START,
	payload: updateData,
});

export const updateBusinessFundDetailsSuccess = (successData: any) => ({
	type: businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_SUCCESS,
	payload: successData,
});

export const updateBusinessFundDetailsFailure = (failureData: any) => ({
	type: businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_FAILURE,
	payload: failureData,
});

export const updateBusinessFundDetailsResponseResetStart = () => ({
	type: businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
});

export const updateBusinessFundDetailsResponseChanged = () => ({
	type: businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE BUSINESS FUND DETAILS END *********************** */

/** ***************** GET BUSINESS FUND LIST START *********************** */
export const getBusinessFundListStart = (getData: any) => ({
	type: businessFundActionTypes.GET_BUSINESS_FUND_LIST_START,
	payload: getData,
});

export const getBusinessFundListSuccess = (successData: any) => ({
	type: businessFundActionTypes.GET_BUSINESS_FUND_LIST_SUCCESS,
	payload: successData,
});

export const getBusinessFundListFailure = (failureData: any) => ({
	type: businessFundActionTypes.GET_BUSINESS_FUND_LIST_FAILURE,
	payload: failureData,
});

export const getBusinessFundListResponseResetStart = () => ({
	type: businessFundActionTypes.GET_BUSINESS_FUND_LIST_RESPONSE_RESET,
});

export const getBusinessFundListResponseChanged = () => ({
	type: businessFundActionTypes.GET_BUSINESS_FUND_LIST_RESPONSE_CHANGED,
});

/** ***************** GET BUSINESS FUND LIST END *********************** */

/** ***************** FETCH BUSINESS FUND DETAILS START *********************** */
export const fetchBusinessFundDetailsStart = (fetchData: any) => ({
	type: businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_START,
	payload: fetchData,
});

export const fetchBusinessFundDetailsSuccess = (successData: any) => ({
	type: businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchBusinessFundDetailsFailure = (failureData: any) => ({
	type: businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchBusinessFundDetailsResponseResetStart = () => ({
	type: businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
});

export const fetchBusinessFundDetailsResponseChanged = () => ({
	type: businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH BUSINESS FUND DETAILS END *********************** */

/** ***************** DELETE BUSINESS FUND DETAILS START *********************** */
export const deleteBusinessFundDetailsStart = (deleteData: any) => ({
	type: businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_START,
	payload: deleteData,
});

export const deleteBusinessFundDetailsSuccess = (successData: any) => ({
	type: businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteBusinessFundDetailsFailure = (failureData: any) => ({
	type: businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteBusinessFundDetailsResponseResetStart = () => ({
	type: businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
});

export const deleteBusinessFundDetailsResponseChanged = () => ({
	type: businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE BUSINESS FUND DETAILS END *********************** */

/** ***************** FETCH ALL BUSINESS FUND LIST START *********************** */
export const fetchAllBusinessFundListStart = (fetchBusinessFunds: any) => ({
	type: businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_START,
	payload: fetchBusinessFunds,
});

export const fetchAllBusinessFundListSuccess = (successData: any) => ({
	type: businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_SUCCESS,
	payload: successData,
});

export const fetchAllBusinessFundListFailure = (failureData: any) => ({
	type: businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_FAILURE,
	payload: failureData,
});

export const fetchAllBusinessFundListResponseResetStart = () => ({
	type: businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_RESPONSE_RESET,
});

export const fetchAllBusinessFundListResponseChanged = () => ({
	type: businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL BUSINESS FUND LIST END *********************** */
